<template>
  <div class="login-container">
    <el-form ref="loginFormRef"  :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on"
      label-position="left">
      <!-- <img
        src="../../../assets/images/login/logo.png"
        class="logo"
      >  -->
    
         <el-dropdown>
          <span class="laguaes_change">
            <img src="../../../assets/images/public/language.png" alt="">
           </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="setlaguase('en')">English</el-dropdown-item>
              <el-dropdown-item @click="setlaguase('zh-cn')">简体中文</el-dropdown-item>
              <el-dropdown-item @click="setlaguase('ko')">한국어</el-dropdown-item>
              <el-dropdown-item @click="setlaguase('de')">Deutsch</el-dropdown-item>
              <el-dropdown-item @click="setlaguase('fr')">Français</el-dropdown-item>
              <el-dropdown-item @click="setlaguase('ja')">日本語</el-dropdown-item>
              <el-dropdown-item @click="setlaguase('nl')">Dutch</el-dropdown-item>
              <el-dropdown-item @click="setlaguase('pl')">Polski</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

      <p class="projectLogo"><img src="../../../assets/images/login/CARS.png" class="login-title">{{$t('robot.projectTtitle')}}</p>
      <!-- <div class="title-container">
        <span class="title">
          {{ $t("login.title") }}
        </span>
        <LangSelect
          class="set-language"
        />
      </div> -->

      <el-form-item prop="company_id" v-if="company_idFlag">
        <span class="svg-container">
          <img src="../../../assets/images/login/epNumber.png">
        </span>
        <el-input ref="userNameRef" v-model="loginForm.company_id" :placeholder="$t('login.company_id')"
          name="company_id" type="text" tabindex="1" autocomplete="on" maxlength="30" />
      </el-form-item>

      <el-form-item prop="username">
        <span class="svg-container">
          <img src="../../../assets/images/login/userName.png">
        </span>
        <el-input v-model="loginForm.username" ref="username" :placeholder="$t('login.username')" type="text"
          tabindex="1" autocomplete="on" maxlength="20" />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
        <el-form-item prop="plaintext_password">
          <span class="svg-container">
            <img src="../../../assets/images/login/password.png">
          </span>
          <el-input :key="passwordType" ref="passwordRef" v-model="loginForm.plaintext_password" :type="passwordType"
            :placeholder="$t('login.password')" name="password" tabindex="2" autocomplete="on"  maxlength="20"
            @keyup="checkCapslock" @keyup.enter="agreementConfirmation" @input="passwordInput" />
            <img  @click="showPwd()" class="eye" :src="eyeFlag ? eyeSrcHide : eyeSrcShow">
          <!-- <span
            class="show-pwd"
            @click="showPwd"
          >
            <img src="../../../assets/images/login/hide-show.png">
          </span> -->
        </el-form-item>
      </el-tooltip>

      <el-checkbox id="checkbox" v-model="loginForm.forgetPassword">{{$t('login.remTheNub')}}</el-checkbox>

      <div class="loginbtnclass">
        <el-button :loading="loading" type="primary" style="width:100%; height:40px; margin-top: 30px;"
        @click.prevent="agreementConfirmation">
        {{ $t("login.logIn") }}
      </el-button>
      </div>
      <div class="agreement">
        <el-checkbox v-model="agrFlag" size="large" />
        <div>
          {{ $t("public.iHaveReadAndAgree") }}
          <a target="_blank" :href="language == 'zh-cn' ? agreementCN : agreementEN">{{ $t("public.userAgreement") }}</a>
          {{ $t("public.gentle") }}
          <a target="_blank" :href="language == 'zh-cn' ? privacyCN : privacyEN">{{ $t("public.privacyAgreement") }}</a>
        </div>
      </div>

    </el-form>

    <!-- <div class="footer_login"> -->
    <!-- <p>
        <span>{{ $t("login.loginAgree") }}</span>  
        <span><Agreement /></span>
      </p> -->
    <!-- <p>©&emsp;2021{{ $t("login.companyProducts") }}</p> -->
    <!-- </div> -->
    <el-dialog
    v-model="dialogOpen"
    :title="$t('public.tips')"
    width="30%"
    :before-close="handleClose"
  >
    <span>
      {{ $t("public.pleaseAgreeFirst") }}
      <a style="color: #1890FF;" target="_blank" :href="language == 'zh-cn' ? agreementCN : agreementEN">
      {{ $t("public.userAgreement") }}</a> {{ $t("public.gentle") }}
      <a style="color: #1890FF;" target="_blank" :href="language == 'zh-cn' ? privacyCN : privacyEN">{{ $t("public.privacyAgreement") }}</a>
    </span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogOpen = false">{{ $t("universality.cancel") }}</el-button>
        <el-button type="primary" @click="dialogConfirm">
          {{ $t("public.agreeWith") }}
        </el-button>
      </span>
    </template>
  </el-dialog>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
  toRefs,
  onBeforeUnmount
} from 'vue'
import LangSelect from '@/components/lang_select/Index.vue'
import { isValidUsername } from '@/utils/validate'
import { useRoute, LocationQuery, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { UserActionTypes } from '@/store/modules/user/action-types'
import Agreement from './Agreement.vue'
// import { useI18n } from 'vue-i18n'
import i18n from '@/locales/index'
import { ElMessage } from "element-plus";
import {getNowDate} from '@/utils/timeFormat'
import { chineseVerification } from '@/utils/validate'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { getCurrentInstance } from 'vue'
import {getAgreement} from '@/apis/home'
import { getLanguage } from "@/utils/cookies";
export default defineComponent({
  components: {
    LangSelect,
    Agreement
  },
  setup() {
    var instanceData:any
    const userNameRef = ref(null) // 企业号
    const passwordRef = ref(null)
    const loginFormRef = ref(null)
    const username = ref(null) // 账号
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    // const { t } = useI18n()

    const state = reactive({
      eyeFlag: true,
      eyeSrcHide: require('../../../assets/images/public/passWord-hide.png'),
      eyeSrcShow: require('../../../assets/images/public/passWord-show.png'),
      company_idFlag: true,
      loginForm: {
        username: '' as any,
        plaintext_password: '' as any,
        password: '' as any,
        company_id: '' as any,
        forgetPassword: false
      },
      loginRules: {
        company_id: [{ required: true, message: i18n.global.t('login.tip_company'), trigger: 'blur' }],
        username: [{ required: true, message: i18n.global.t('login.tip_username'), trigger: 'blur' }],
        password: [{ required: true, message: i18n.global.t('login.tip_pwd'), trigger: 'blur' }],
      },
      passwordType: 'password',
      loading: false,
      showDialog: false,
      capsTooltip: false,
      redirect: '',
      otherQuery: {},
      cacheObj: '' as any,
      dialogOpen: false,
      privacyCN: '',
      privacyEN: '',
      agreementCN: '',
      agreementEN: '',
      agrFlag: false,
      language: getLanguage()
    })

    const methods = reactive({
      validateUsername: (rule: any, value: string, callback: Function) => {
        if (!isValidUsername(value)) {
          callback(new Error('Please enter the correct user name'))
        } else {
          callback()
        }
      },
      validatePassword: (rule: any, value: string, callback: Function) => {
        if (value.length < 6) {
          callback(new Error('The password can not be less than 6 digits'))
        } else {
          callback()
        }
      },
      setlaguase(lang:string) {
           console.log(lang)
           store.dispatch(AppActionTypes.ACTION_SET_LANGUAGE, lang)
          //  console.log(locale)
           location.reload()
          //  locale.value = lang
          // reloads()
     },
      checkCapslock: (e: KeyboardEvent) => {
        const { key } = e
        state.capsTooltip =
          key !== null && key.length === 1 && key >= 'A' && key <= 'Z'
      },
      passwordInput(){
        state.loginForm.plaintext_password = chineseVerification(state.loginForm.plaintext_password)
      },
      showPwd: () => {
        state.eyeFlag = !state.eyeFlag
        if (state.eyeFlag) {
          state.passwordType = 'password'
        } else {
          state.passwordType = 'text'
        }
        nextTick(() => {
          (passwordRef.value as any).focus()
        })
      },
      dialogConfirm() {
        state.agrFlag = true
        state.dialogOpen = false
        methods.handleLogin()
      },
      handleClose(){
        state.dialogOpen = false
      },
      agreementConfirmation(){
        if(state.agrFlag){
          methods.handleLogin()
        }else{
          state.dialogOpen = true
        }
      },
      handleLogin: () => {
        (loginFormRef.value as any).validate(async (valid: boolean) => {
          if (valid) {
            state.loading = true
            state.loginForm.password = JSON.parse(JSON.stringify(state.loginForm.plaintext_password)) 

            // 解密
            if(state.loginForm.password.length > 20){
              state.loginForm.password = instanceData.proxy.$AES_Decrypt(state.loginForm.password)  
            }
            //加密
            state.loginForm.password = instanceData.proxy.$AES_Encrypt(state.loginForm.password)  
            let res =  await store.dispatch(UserActionTypes.ACTION_LOGIN, state.loginForm)
            // router
            //   .push({
            //     // path: state.redirect || '/robot/robotList',
            //     path: '/home/Homes',
            //     query: state.otherQuery
            //   })
            //   .catch(err => {
            //     console.warn(err)
            //   })
            // // 存用户信息和登录时间
            // let personalInfoObj = {
            //   company_id: state.loginForm.company_id,
            //   username: state.loginForm.username,
            //   loginTime: getNowDate()
            // }
            // localStorage.setItem('userInfo', JSON.stringify(personalInfoObj))
            // // Just to simulate the time of the request
            // // 记住密码 就存储账号 密码 企业号
            // if (state.loginForm.forgetPassword) {
            //   let obj = {
            //     cacheEnterprise: state.loginForm.company_id,
            //     cacheUser: state.loginForm.username,
            //     cachePassword: state.loginForm.password,
            //     forgetPasswordFlag: state.loginForm.forgetPassword
            //   }
            //   sessionStorage.setItem('cacheObj', JSON.stringify(obj))
            // } else {
            //   sessionStorage.setItem('cacheObj', '')

            // }
            setTimeout(() => {
              state.loading = false
            }, 0.5 * 1000)
          } else {
            return false
          }
        })
      }
    })

    function getOtherQuery(query: LocationQuery) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {} as LocationQuery)
    }

    watch(() => route.query, query => {
      if (query) {
        state.redirect = query.redirect?.toString() ?? ''
        state.otherQuery = getOtherQuery(query)
      }
    })

    onMounted(() => {
      getAgreement().then((res:any) => {
        console.log('res',res)
        res.data.forEach((item:string) => {
          let arr = item.split('_')
          if(arr.indexOf('privacy') != -1 && arr.indexOf('CN.html') != -1){
            state.privacyCN = item
          }else if(arr.indexOf('privacy') != -1 && arr.indexOf('EN.html') != -1){
            state.privacyEN = item
          }else if(arr.indexOf('agreement') != -1 && arr.indexOf('CN.html') != -1){
            state.agreementCN = item
          }else if(arr.indexOf('agreement') != -1 && arr.indexOf('EN.html') != -1){
            state.agreementEN = item
          }
        })
      })
      // 用户记住了密码就取缓存数据 直接赋值
      instanceData = getCurrentInstance()
      state.cacheObj = localStorage.getItem('cacheObj')
      if (state.cacheObj) {
        let cacheData = JSON.parse(state.cacheObj)
        state.loginForm.forgetPassword = cacheData.forgetPasswordFlag
        state.loginForm.company_id = cacheData.cacheEnterprise
        state.loginForm.plaintext_password = cacheData.cachePassword
        state.loginForm.username = cacheData.cacheUser
      }
      if(route.query.companyId){
          state.company_idFlag = false
          state.loginForm.company_id = route.query.companyId
        }

      if (state.loginForm.company_id === '') {
        (userNameRef.value as any).focus()
      } else if (state.loginForm.plaintext_password === '') {
        (passwordRef.value as any).focus()
      } else if (state.loginForm.username === '') {
        (username.value as any).focus()
      }
         document.getElementsByTagName('body')[0].style.overflowY = 'hidden'
    })
    onBeforeUnmount(()=>{
      document.getElementsByTagName('body')[0].style.overflowY = ''
    })
    return {
      userNameRef,
      passwordRef,
      loginFormRef,
      username,
      ...toRefs(state),
      ...toRefs(methods),
      route
      // t
    }
  }
})
</script>

<style lang="scss">
// References: https://www.zhangxinxu.com/wordpress/2018/01/css-caret-color-first-line/
@supports (-webkit-mask: none) and (not (cater-color: $loginCursorColor)) {
  .login-container .el-input {
    input {
      color: #000;
    }
  }
}

  .login-form{
    .el-dropdown{
      position: absolute;
      top: 52px;
      right: 180px;
    }
  }

.login-container {
  background: #f1f2f6 url("../../../assets/images/login/banner.png") no-repeat;
  background-size: 100% 100%;;
  // background-position: 100px bottom;
  // background-size: contain;

  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      height: 47px;
      background: transparent;
      border: 0px;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      // color: #000;
      // caret-color: $loginCursorColor;
      -webkit-appearance: none;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #000 !important;
      }

    }

    input::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #ccc !important;
    }

    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #ccc;
    }

    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #ccc;
    }

    input:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #ccc;
    }
  }

  .el-form-item {
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 5px;
    width: 56%;
    margin: 25px 0 25px 25%;
  }

  .is-error{
    border: 1px solid red;
  }

  // 记住密码样式
  #checkbox {
    position: relative;
    left: 25%;
  }

  // 密码显示隐藏样式
  .el-input--medium .el-input__icon {
    position: relative;
    right: -34px;
    top: 6px;
  }
}
</style>

<style lang="scss" scoped>
.bodys {
  overflow-y: hidden;
}
.login-container {
  display: flex;
  flex-direction: row-reverse;
  height: 100%;
  overflow: auto;
  // background-color: #f0f2f5;

  // overflow: hidden;
  // background-color: $loginBg;
 .bglogin{
  //  background: #f1f2f6 url("../../../assets/images/login/loginbg.png") no-repeat;
  width: 300px;
  height: 260px;
  // background-size: 100%;
 }

  // 密码眼睛样式
  .eye {
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: 14px;
    width: 18px;
    height: 18px;
  }

  .login-form {
    position: relative;
    right: 52px;
    top: 15%;
    width: 760px;
    height: 700px;
    max-width: 100%;
    padding-top: 155px;
    background: url("../../../assets/images/login/loginbg.png") no-repeat;
    background-size: 100% 100%;

    .laguaes_change{

      img{
        width: 24px;
      }
    }
  }
.loginbtnclass{
  margin: 0 25%;
  width: 56%;
}
.agreement{
  display: flex;
  position: relative;
  top: 10px;
  left: 189px;
  width: 495px;
  font-size: 14px;
  color: #606266;
  div{
    margin-left: 5px;
    width: 495px;
    a{
      color: #1890FF;
    }
  }
}
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #000;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    text-align: center;

    .title {
      display: inline-block;
      padding: 0 6px 10px;
      // border-bottom: 2px solid #1890ff;
      text-align: center;
      font-size: 14px;
      color: #1890ff;
      font-weight: bold;
      margin: 40px auto;
    }

    .set-language {
      color: #000;
      position: absolute;
      top: 26px;
      font-size: 18px;
      right: 0px;
      cursor: pointer;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  .logo {
    margin-left: -20px;
  }

  .footer_login {
    margin-top: 100px;
    text-align: center;
    color: #666;

    p {
      margin-bottom: 6px;
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }

  .projectLogo {
    .login-title {
      display: block;
      height: 24px;
      margin-right: 10px;
      margin-top: 4px;
    }

    margin: 0 0 40px 0;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.8500);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>
